import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { useToast } from "@/hooks/use-toast";
import { supabase } from "@/integrations/supabase/client";
import { CreditCard, Plus } from "lucide-react";
import { useState } from "react";

const PaymentMethods = () => {
  const { toast } = useToast();
  const [isLoading, setIsLoading] = useState(false);

  const handleAddPaymentMethod = async () => {
    try {
      setIsLoading(true);
      const { data: { session } } = await supabase.auth.getSession();
      
      if (!session) {
        throw new Error('No session found');
      }

      const response = await fetch(
        'https://rjtucjbqtcgxxancxryf.functions.supabase.co/create-checkout-session',
        {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${session.access_token}`,
          },
        }
      );

      const { url, error } = await response.json();
      
      if (error) throw error;
      if (url) window.location.href = url;
      
    } catch (error) {
      toast({
        title: "Error",
        description: "Failed to initialize payment setup. Please try again.",
        variant: "destructive",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background pb-16">
      <main className="container mx-auto px-4 py-6 space-y-6">
        <Button 
          className="w-full"
          onClick={handleAddPaymentMethod}
          disabled={isLoading}
        >
          <Plus className="h-4 w-4 mr-2" />
          {isLoading ? "Setting up..." : "Add Payment Method"}
        </Button>

        <Card className="p-6">
          <div className="text-center text-muted-foreground">
            <CreditCard className="h-12 w-12 mx-auto mb-4 text-muted-foreground" />
            <p>No payment methods added yet</p>
          </div>
        </Card>
      </main>
    </div>
  );
};

export default PaymentMethods;
